module.exports = "/_next/static/images/offers4-2x-c876e9f2d086335359101ba9e4e76afc.jpg.webp";